// @ts-check
/**
 * Loads the airport dataset. The website fetches it from its own origin
 * (`/data/airports.json`, generated by `scripts/build-airports.mjs`); the Chrome
 * extension will bundle the same file.
 * @module data/airportSource
 */
import { decodeDataset } from '../core/airports.js';

/**
 * @param {string} url
 * @param {typeof fetch} [fetchImpl]
 * @returns {Promise<import('../core/airports.js').Airport[]>}
 */
export async function loadAirportDataset(url, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(url, { headers: { accept: 'application/json' } });
  if (!response.ok) throw new Error(`Airport data request failed (HTTP ${response.status})`);
  return decodeDataset(await response.json());
}

/**
 * Metadata about the dataset (generation date, sources). Failure is not fatal.
 * @param {string} url
 * @param {typeof fetch} [fetchImpl]
 * @returns {Promise<Record<string, unknown> | null>}
 */
export async function loadDatasetMeta(url, fetchImpl = globalThis.fetch) {
  try {
    const response = await fetchImpl(url, { headers: { accept: 'application/json' } });
    if (!response.ok) return null;
    const meta = await response.json();
    return meta && typeof meta === 'object' ? meta : null;
  } catch {
    return null;
  }
}
